import { render } from "./PostpaidQA.vue?vue&type=template&id=02807798&scoped=true"
import script from "./PostpaidQA.vue?vue&type=script&lang=js"
export * from "./PostpaidQA.vue?vue&type=script&lang=js"

import "./PostpaidQA.vue?vue&type=style&index=0&id=02807798&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02807798"]])

export default __exports__